import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom';
import JobCarousel from './JobCarousel';
import { Job } from './App';
import { CircularProgress, Typography } from '@material-ui/core';

interface ParamTypes {
    classification: string;
}

interface Props {
    jobs?: Array<Job>
    loading: boolean
}

export default function JobClassificationWidget({ jobs, loading }: Props) {

    const { classification } = useParams<ParamTypes>();

    const [similarJobs, setSimilarJobs] = useState<Array<Job>>([])

    useEffect(() => {
        if(jobs) {
            if(jobs.length > 0) {
                let similarJobsList: Array<Job> = []
                jobs.forEach((j: Job) => {
                    if(j.Classification === classification) {
                        similarJobsList.push(j)
                    }
                })
                setSimilarJobs(similarJobsList)
            }
        }
    }, [classification, jobs])

    return (
        <div>
            <div style={{display: "flex", justifyContent: "center"}}>
                <Typography variant="h5" style={{color: "#259a49"}}>
                    Available Jobs
                </Typography>
            </div>
            <div style={{display: "flex", justifyContent: "center", paddingBottom: 32}}>
                {loading ?
                    <CircularProgress style={{marginTop: 32}} size={80} color="primary" />
                :
                    <JobCarousel similarJobs={similarJobs} jobs={jobs} />
                }
               
            </div>
        </div>
    )
}
